/* eslint-disable-next-line no-undef */
class QuantityInput extends HTMLElement {
  constructor () {
    super()
    const isProductPage = document.body.classList.contains('product')
    this.min = parseInt(this.getAttribute('data-min'))
    this.max = parseInt(this.getAttribute('data-max'))
    this.step = parseInt(this.getAttribute('step'))
    this.value = parseInt(this.getAttribute('value'))
    this.input = this.querySelector('.quantity__input')
    this.buttons = this.querySelectorAll('button')
    this.changeEvent = new Event('change', { bubbles: true })
    this.isAvailable = document.querySelector('variant-selects[id*="__main"] > script') != null ? JSON.parse(document.querySelector('variant-selects[id*="__main"] > script').textContent).available : true

    if (this.input) {
      this.input.addEventListener('change', this.onInputChange.bind(this))
    }
    if (this.buttons) {
      this.buttons.forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      )
    }

    if (!isProductPage) {
      return
    }

    this.select = document.createElement('select')
    this.select.classList.add('quantity__select')
    this.select.setAttribute('data-value', this.value)

    for (let i = this.min; i <= this.max; i += this.step) {
      const option = document.createElement('option')
      option.value = i
      option.text = i
      if (i === this.min) { option.setAttribute('selected', 'selected') }
      this.select.appendChild(option)
    }

    this.select.value = this.value

    // Add event listener for select change
    this.select.addEventListener('change', this.onSelectChange.bind(this))

    // Append both input and select elements to the custom element
    this.appendChild(this.select)

    // Listen for the variantChanged event and update the isAvailable value
    // eslint-disable-next-line no-undef
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
      this.isAvailable = event.data.isAvailable
    })
  }

  onButtonClick (event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
  }

  onInputChange () {
    this.validateQtyRules()
  }

  validateQtyRules () {
    const value = parseInt(this.input.value)
    if (this.input.min) {
      const min = parseInt(this.input.min)
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      buttonMinus.classList.toggle('disabled', value <= min)
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      buttonPlus.classList.toggle('disabled', value >= max)
    }
  }

  onSelectChange (event) {
    this.value = parseInt(event.target.value)
    this.input.value = this.value

    this.select.setAttribute('data-value', this.value)
    const options = this.select.querySelectorAll('option')
    options.forEach(option => {
      option.removeAttribute('selected')
    })

    const selectedOption = this.select.querySelector(`option[value="${this.value}"]`)
    if (selectedOption) {
      selectedOption.setAttribute('selected', 'selected')
    }
    const stickyQuantityInput = document.querySelector('.quantity__input-sticky')
    if (stickyQuantityInput) {
      stickyQuantityInput.value = this.value
      stickyQuantityInput.setAttribute('value', this.value)
    }

    const stickyQuantityInputMobile = document.querySelector('.quantity__input-sticky-mobile')
    if (stickyQuantityInputMobile) {
      stickyQuantityInputMobile.value = this.value
      stickyQuantityInputMobile.setAttribute('value', this.value)
    }
    updatePrices(null, null, this.isAvailable)
    this.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
/* eslint-disable-next-line no-undef */
customElements.define('quantity-input', QuantityInput)

// Helper function to format price with cents as superscript
function formatPrice (priceString) {
  const priceLength = priceString.length - 2
  const priceCents = priceString.slice(-2)
  const priceDollar = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(priceString.slice(0, priceLength))
  return `${priceDollar}<span class="decimals">${priceCents}</span>`
}

/* eslint-disable-next-line no-unused-vars */
function updatePrices (currentPriceValue, currentComparePriceValue, isAvailable) {
  // When called without price (from sticky ATC), we need to get the variant from the source that triggered the change
  if (!currentPriceValue) {
    // Try to get from either main or sticky variant selects
    const mainVariantSelects = document.querySelector('variant-selects[data-section*="__main"]')
    const stickyVariantSelects = document.querySelector('variant-selects[data-section*="__sleepdoctor_sticky_add_to_cart"]')

    // Use whichever has the current variant (prioritize main)
    let variantSource = null
    if (mainVariantSelects && mainVariantSelects.currentVariant) {
      variantSource = mainVariantSelects
    } else if (stickyVariantSelects && stickyVariantSelects.currentVariant) {
      variantSource = stickyVariantSelects
    }

    if (variantSource && variantSource.currentVariant) {
      currentPriceValue = variantSource.currentVariant.price
      currentComparePriceValue = variantSource.currentVariant.compare_at_price
      isAvailable = variantSource.currentVariant.available
    }
  }

  // Get quantity - check multiple possible sources
  let currentQuantity = '1'

  // First try main product quantity selector
  const mainQuantityElement = document.querySelector('.main-product .product__info-container .quantity__select')
  if (mainQuantityElement) {
    currentQuantity = mainQuantityElement.getAttribute('data-value') || mainQuantityElement.value || '1'
  }

  // Also check the quantity input if select not found
  if (currentQuantity === '1') {
    const quantityInput = document.querySelector('.product__info-container .quantity__input')
    if (quantityInput) {
      currentQuantity = quantityInput.value || '1'
    }
  }

  // Update sale prices
  if (currentPriceValue) {
    // Format price for display
    const totalPrice = (parseInt(currentPriceValue) * parseInt(currentQuantity)).toString()
    const formattedPrice = formatPrice(totalPrice)
    const singleFormattedPrice = formatPrice(currentPriceValue.toString())

    // Update main product price
    const mainPrice = document.querySelector('.product__info-wrapper .price-item--sale') ||
                     document.querySelector('.product__info-container .price-item--sale')
    if (mainPrice) {
      mainPrice.setAttribute('data-price', currentPriceValue)
      mainPrice.innerHTML = formattedPrice
    }

    // Update sticky cart price (single unit price, not multiplied by quantity)
    const stickyPrice = document.querySelector('.sticky-price .price-item--sale')
    if (stickyPrice) {
      stickyPrice.setAttribute('data-price', currentPriceValue)
      stickyPrice.innerHTML = singleFormattedPrice
    }

    // Update single unit price display
    const singlePrice = document.querySelector('[id*="price-template"] .price__sale .price-item--sale')
    if (singlePrice) {
      singlePrice.setAttribute('data-price', currentPriceValue)
      singlePrice.innerHTML = singleFormattedPrice
    }
  }

  // Update compare prices
  if (currentComparePriceValue) {
    // Format compare price for display
    const totalComparePrice = (parseInt(currentComparePriceValue) * parseInt(currentQuantity)).toString()
    const formattedComparePrice = formatPrice(totalComparePrice)
    const singleFormattedComparePrice = formatPrice(currentComparePriceValue.toString())

    // Update main compare price
    const mainComparePrice = document.querySelector('.product__info-wrapper .price-item--regular') ||
                            document.querySelector('.product__info-container .price-item--regular')
    if (mainComparePrice) {
      mainComparePrice.setAttribute('data-price-regular', currentComparePriceValue)
      mainComparePrice.innerHTML = formattedComparePrice
    }

    // Update sticky compare price (single unit price, not multiplied by quantity)
    const stickyComparePrice = document.querySelector('.sticky-price .price-item--regular')
    if (stickyComparePrice) {
      stickyComparePrice.setAttribute('data-price-regular', currentComparePriceValue)
      stickyComparePrice.innerHTML = singleFormattedComparePrice
    }

    // Update single unit compare price
    const singleComparePrice = document.querySelector('[id*="price-template"] .price__sale .price-item--regular')
    if (singleComparePrice) {
      singleComparePrice.setAttribute('data-price-regular', currentComparePriceValue)
      singleComparePrice.innerHTML = singleFormattedComparePrice
    }
  }

  // Update quantity input value
  const quantityInput = document.querySelector('.product__info-container .quantity__input')
  if (quantityInput) {
    quantityInput.setAttribute('value', currentQuantity)
  }

  // Update add to cart button text
  // Use comprehensive selector to catch all add to cart buttons (main product and sticky)
  const addToCartButtons = document.querySelectorAll('button[name="add"], .product-form__submit')
  let togglesActive = 0

  // Check for Rebuy toggles
  // eslint-disable-next-line no-undef
  if (sessionStorage.getItem('rebuyLoaded') === 'true') {
    // eslint-disable-next-line no-unused-vars
    togglesActive = document.querySelectorAll('.add-to-cart-toggle:checked').length
  }

  addToCartButtons.forEach(button => {
    // Skip if button is not visible (e.g., mobile sticky button on desktop)
    if (button.offsetParent === null) return

    // Find the text element within the button (could be span or direct text)
    const textElement = button.querySelector('span') || button

    if (!isAvailable) {
      textElement.textContent = 'Sold out'
      button.disabled = true
      return
    }

    // Enable button if available
    button.disabled = false

    // Check if this is a sticky button by looking at parent elements
    const isStickyButton = button.closest('.sd-sticky-button, .sticky-button-add-to-cart')

    if (window.innerWidth <= 767 && !isStickyButton) {
      textElement.textContent = 'Add to Cart'
    }
  })
}

// Make updatePrices globally accessible so global.js can call it
window.updatePrices = updatePrices
